import { LoaderIcon } from '@shared/components/Icons';
import { FC } from 'react';

export const Loader: FC<{ width: number; height: number }> = ({
  width,
  height,
}) => (
  <div className="animate-spin [animation-duration:3s]">
    <LoaderIcon width={width} height={height} />
  </div>
);
